// extracted by mini-css-extract-plugin
export var table = "_6b204a6b8bb032354806e3fd86e222be-css";
export var numberCell = "f2b0f2607bc1ca9e2ecefa0e5f7a53e0-css";